// PAQUETES
import {useNavigate, useLocation} from 'react-router-dom';
import React, {useState, useEffect, useRef} from "react";
import axios from "axios";
import Swal from 'sweetalert2';
// componentes
import ZonaCargando from '../paginas/alertas/zonaCargando';
import ToggleTema from '../componentesEspeciales/toggleTema';
// Estilos
import '../estilos/headerGlobal.css';


function HeaderGlobal({ usuario, cargandoUsuario, setUsuario, categorias, subcategorias }){

    const navigate = useNavigate();
    const location = useLocation();

    const scrollContainerRef = useRef(null);
    const hideMenuTimeoutRef = useRef(null);
    const [menuVisible, setMenuVisible]   = useState(false);
    const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
    const [activeIndex, setActiveIndex]   = useState(null);
    const [cargando, setCargando]         = useState(false); 
    const [busquedaHeader, setBusquedaHeader] = useState("");
    const [ciudadHeader, setCiudadHeader] = useState("");
    const [tieneReservasActivas, setTieneReservasActivas] = useState(false);
    const [hayNotificacionesNoLeidas, setHayNotificacionesNoLeidas] = useState(false);
    const cargandoFinal = Boolean(cargandoUsuario) || Boolean(cargando); // controla cargando de usuario direccionamiento, y cargando local
    const esComprador = usuario?.modo === "Comprador";
    const colorModo = esComprador ? "var(--bs-primary)" : "var(--bs-secondary)";
    const usuarioVerificado =  usuario?.verificacionIdentidad?.estado === "aprobado"; 

   

    useEffect(() => {
    async function obtenerReservaActiva() {
        try {
            if (!usuario?.idUsuario) {
                setTieneReservasActivas(false);
                return;
            }

            const resReserva = await axios.post("/obtener-reserva", {
                params: { idComprador: usuario.idUsuario }
            });

            setTieneReservasActivas(Boolean(resReserva?.data?.existe));
        } catch (err) {
            console.log("error obteniendo reservas activas:", err);
            setTieneReservasActivas(false);
        }
    }

    obtenerReservaActiva();
}, [usuario?.idUsuario, location.pathname]);


    useEffect(() => {
    async function obtenerNotificacionesNoLeidas() {
        try {
            if (!usuario?.idUsuario) {
                setHayNotificacionesNoLeidas(false);
                return;
            }

            const resNotificaciones = await axios.post("/notificaciones/contar-no-leidas", {
                params: { idUsuario: usuario.idUsuario, rolDestino: "Comprador" }
            });

            setHayNotificacionesNoLeidas(Number(resNotificaciones?.data?.noLeidas || 0) > 0);
        } catch (err) {
            console.log("error obteniendo notificaciones no leídas:", err);
            setHayNotificacionesNoLeidas(false);
        }
    }

    obtenerNotificacionesNoLeidas();
}, [usuario?.idUsuario, location.pathname]);
   


    const scroll = (direction) => {
        const { current } = scrollContainerRef;
        if (direction === 'left') {
            current.scrollBy({ left: -200, behavior: 'smooth' });
        } else {
            current.scrollBy({ left: 200, behavior: 'smooth' });
        }
    };

    const handleMouseEnter = (event, index) => {
        if (hideMenuTimeoutRef.current) {
            clearTimeout(hideMenuTimeoutRef.current);
            hideMenuTimeoutRef.current = null;
        }

        const rect = event.currentTarget.getBoundingClientRect();
        setMenuPosition({
            top: rect.bottom + window.scrollY,
            left: rect.left + rect.width / 2
        });
        setActiveIndex(index);
        setMenuVisible(true);
    };

    function irABusqueda({ categoria = null, subcategoria = null }) {
    return navigate("/busqueda", {
        state: {
            filtros: {
                categoria,
                subcategoria,
            }
        }
    });
}

    const handleMouseLeave = () => {
        if (hideMenuTimeoutRef.current) {
            clearTimeout(hideMenuTimeoutRef.current);
        }

        hideMenuTimeoutRef.current = setTimeout(() => {
            setMenuVisible(false);
            setActiveIndex(null);
        }, 180);
    };

    function handleBuscarHeader(e) {
        e.preventDefault();

        const palabra = (busquedaHeader || "").trim();
        const ciudad = (ciudadHeader || "").trim();

        const filtros = {
            palabra: palabra || null,
            ciudad: ciudad || null,
        };

       

        // Si ya estamos en /busqueda, forzamos recarga (pero preservando filtros en la URL)
        if (location?.pathname === '/busqueda') {
            navigate("/busqueda", { state: { filtros } });
            window.location.reload();
            return;
        }

        return navigate("/busqueda", { state: { filtros } });
    }


    function cerrarSesion(event) {
        event.preventDefault();
        setCargando(true);
    
        localStorage.clear(); // Limpiamos el almacenamiento local.
        axios.post("/cerrar-sesion")
        .then(function(response) {
            setCargando(false);
            //console.log(response);
            if (typeof setUsuario === "function") setUsuario(null); // aseguramos que setUsuario exista para ponerlo en null.
            navigate("/"); // Redirige a la página principal
        })
        .catch(function(error) { console.error("Error al cerrar sesión:", error); });
    }


    async function cambiarModo(){
        if (!usuario) return;
        setCargando(true);

        try{
            const response = await axios.post("/cambiar-modo", { params: {usuario: usuario.username, modoActual: usuario.modo }});
            setCargando(false);

            if(response.status===200){
                console.log("modo cambiado correctamente, nuevoModo: ", response.data.nuevoModo);

                if (typeof setUsuario === "function") {
                    setUsuario((prev) => prev ? { ...prev, modo: response.data.nuevoModo } : prev);
                }

                Swal.fire({
                icon: 'success',
                title: "Éxito",
                text: "Modo cambiado correctamente.",
                customClass: {
                    popup: 'mi-modal',
                    confirmButton: 'mi-boton-confirmar',
                    cancelButton: 'mi-boton-cancelar'
                },
                showCancelButton: false,
                confirmButtonText: 'Continuar'
                }).then((result) => {
                if (result.isConfirmed) {
                    response.data.nuevoModo === "Comprador" ? navigate("/") : navigate("/vendedor/");
                }
                });
            }

        }
        catch(err){
            setCargando(false);
            Swal.fire({
                icon: 'error',
                title: "Error",
                text: "Error cambiando el modo. Vuelva a intentar",
                customClass: {
                    popup: 'mi-modal',
                    confirmButton: 'mi-boton-confirmar',
                    cancelButton: 'mi-boton-cancelar'
                },
            });
        }
    };



    return(
    <div>
    { (cargandoFinal) ? <ZonaCargando />
    :<div className='contenedorHeader text-light' >

        {/* Cabecera superior */}
        <header className="pt-3 pb-1 px-1 ">
            <div className="container">
                <div className="d-flex flex-wrap align-items-center justify-content-between justify-content-lg-start">
                    {/* Logo */}
                    <a href="/" className="d-flex align-items-center  text-white text-decoration-none"  >
                        <img src="/imagenes/marca/zervicyblancohorizontal.png" alt="Logo" width="200" height="40" />
                    </a>

                    {/* reserva / carrito SOLO EN CELULARES */}
                    <a href="/reserva" className="nav-link text-light d-lg-none ms-auto me-3 d-flex align-items-center" title="Reserva" style={{ lineHeight: 1 }}>
                        <div style={{ position: "relative", display: "inline-block" }}>
                            <i className="bi bi-bag-fill" style={{ fontSize: 18, opacity: 0.9 }}></i>

                            {!tieneReservasActivas ? null : (
                                <span
                                    style={{
                                        position: "absolute",
                                        top: -4,
                                        right: -4,
                                        width: 12,
                                        height: 12,
                                        backgroundColor: "var(--azul-logo-claro)",
                                        borderRadius: "50%",
                                        border: "2px solid white"
                                    }}
                                ></span>
                            )}
                        </div>
                    </a>
                    

                    {/* FORMULARIO BUSQUEDA PCS: MUESTRA EN PANTALLAS, OCULTO EN CELULARES  */}
                    <form onSubmit={handleBuscarHeader} className="d-none d-lg-flex col-lg-auto mb-lg-0 me-lg-3 ms-2" role="search" style={{ flexGrow: 3 }}>
                        <input
                            type="search"
                            className="form-control form-control-dark"
                            placeholder="Buscar..."
                            aria-label="Search"
                            value={busquedaHeader}
                            onChange={(e) => setBusquedaHeader(e.target.value)}
                        />
                    </form>

                    {/* Menú superior: MUESTRA EN PANTALLAS, OCULTO EN CELULARES d-none y d-lg-flex ocultan y muestran el menu en telefonos */}
                    {!usuario ? null 
                    :<ul className="nav d-none d-lg-flex col-lg-auto mb-0 align-items-center justify-content-end me-3" style={{ flexGrow: 1 }}>
                        <li className="d-flex align-items-center">
                            <a href="/usuario/notificaciones" className="nav-link px-2 text-white d-flex align-items-center" title="Notificaciones">
                                <div style={{ position: "relative", display: "inline-block" }}>
                                    <i className="bi bi-bell-fill"></i>

                                    {!hayNotificacionesNoLeidas ? null : (
                                        <span
                                            style={{
                                                position: "absolute",
                                                top: -4,
                                                right: -4,
                                                width: 10,
                                                height: 10,
                                                backgroundColor: "var(--azul-logo-claro)",
                                                borderRadius: "50%",
                                                border: "2px solid white"
                                            }}
                                        ></span>
                                    )}
                                </div>
                            </a>
                        </li>
                        {/* <li className="d-flex align-items-center"><a href="/mis-mensajes" className="nav-link px-2 text-white d-flex align-items-center" title="Mensajes"><i className="bi bi-envelope-paper-fill"></i></a></li> */}
                        <li className="d-flex align-items-center"><a href="/usuario/favoritos" className="nav-link px-2 text-white d-flex align-items-center" title="Favoritos"><i className="bi bi-heart-fill"></i></a></li>
                        <li className="d-flex align-items-center"><a href="/usuario/reservas" className="nav-link px-2 text-white d-flex align-items-center">Mis Reservas</a></li>
                        {/* Modo de usuario */}
                        <li className="d-flex align-items-center mx-3">
                            <div className="form-check form-switch mb-0">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="switchCheckDefault"
                                    checked={esComprador}
                                    onChange={cambiarModo}
                                    style={{
                                        backgroundColor: colorModo,
                                        borderColor: colorModo
                                    }}
                                />
                                <label className="form-check-label" htmlFor="switchCheckDefault">{usuario.modo}</label>
                            </div>
                        </li>
                        {/* Reserva / Carrito */}
                        <li className="d-flex align-items-center ms-1">
                            <a href="/reserva" className="nav-link px-2 text-white d-flex align-items-center" title="Reserva" style={{ lineHeight: 1 }}>
                                <div style={{ position: "relative", display: "inline-block" }}>
                                {/* icono carrito */}
                                <i className="bi bi-bag-fill" style={{ fontSize: 18, opacity: 0.9 }}></i>
                                
                                {/* circulo */}
                                {!tieneReservasActivas ? null : 
                                <span
                                    style={{
                                    position: "absolute",
                                    top: -4,
                                    right: -4,
                                    width: 12,
                                    height: 12,
                                    backgroundColor: "var(--azul-logo-claro)", // tu azul
                                    borderRadius: "50%",
                                    border: "2px solid white"
                                    }}
                                ></span>
                                }
                                </div>
                            </a>
                        </li>
                    </ul>
                    }
                    
                    {/* MODO OSCURO: MUESTRA EN PANTALLAS, OCULTO EN CELULARES */}
                    <div className="d-none d-lg-flex align-items-center me-2">
                        <ToggleTema />
                    </div>

                    {/* INICIAR SESION: MUESTRA EN PANTALLAS, OCULTO EN CELULARES */}
                    <div className="text-end d-none d-lg-flex">
                        {!usuario ? <a href='/iniciar-sesion' type="button" className="btn btn-outline-light me-2">Iniciar Sesión</a>
                        : <div className="btn-group">
                            {/* Icono */}
                            <button
                                type="button"
                                className="btn dropdown-toggle p-0 border-0 bg-transparent position-relative"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <img
                                    src={usuario.avatar}
                                    alt="Avatar"
                                    width="40"
                                    height="40"
                                    className="rounded-circle"
                                />

                                {usuarioVerificado && (
                                    <img
                                        src="https://zervicy.s3.us-east-1.amazonaws.com/imagenes/iconos/autenticado.svg"
                                        alt="Verificado"
                                        width="18"
                                        height="18"
                                        style={{
                                            position: "absolute",
                                            top: -2,
                                            left: -2,
                                            filter: "brightness(0) invert(1) opacity(0.9)",
                                        }}
                                    />
                                )}
                            </button>
                            {/* Menú */}
                            <ul className=" dropdown-menu dropdown-menu-end menu-grande py-3 px-3">
                                <li><a className="dropdown-item" href="/usuario/pagos">Mis Pagos</a></li>
                                <hr />
                                <li><a className="dropdown-item" href="/usuario/mi-cuenta">Mi cuenta</a></li>
                                <li><button onClick={cerrarSesion} className="dropdown-item" type="button">Cerrar Sesión</button></li>
                            </ul>
                        </div>
                        }
                    </div>





                    {/* MENÚ EN CELULARES: OCULTO EN PANTALLAS, MUESTRA EN CELUALRES */}
                    <button className="btn btn-primary d-lg-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#staticBackdrop" aria-controls="staticBackdrop"> <i className="bi bi-list"></i> </button>
                    <div className="offcanvas offcanvas-end" data-bs-backdrop="static" tabIndex="-1" id="staticBackdrop" aria-labelledby="staticBackdropLabel">
                        {/* cabecera */}
                        <div className="offcanvas-header border-bottom border-1 border-dark">
                            {/* Logo */}
                            <a href="/" className="d-flex align-items-center  text-white text-decoration-none"  >
                                <img src="/imagenes/marca/zervicyazulhorizontal.png" alt="Logo" width="200" height="40" className="logo-offcanvas-claro" />
                                <img src="/imagenes/marca/zervicyblancohorizontal.png" alt="Logo" width="200" height="40" className="logo-offcanvas-oscuro" />
                            </a>
                            <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                        </div>

                        {/* cuerpo */}
                        {usuario ?
                        <div className="offcanvas-body">
                            {/* Íconos horizontales */}
                            <ul className="nav justify-content-around mb-4">
                                {/* modo oscuro */}
                                <li className="nav-item d-flex align-items-center">
                                    <ToggleTema sobreFondoOscuro={false} />
                                </li>
                                {/* notificaciones */}
                                <li className="nav-item">
                                    <a href="/usuario/notificaciones" className="nav-link text-dark" title="Notificaciones">
                                        <div style={{ position: "relative", display: "inline-block" }}>
                                            <i className="bi bi-bell-fill"></i>

                                            {!hayNotificacionesNoLeidas ? null : (
                                                <span
                                                    style={{
                                                        position: "absolute",
                                                        top: -4,
                                                        right: -4,
                                                        width: 10,
                                                        height: 10,
                                                        backgroundColor: "var(--azul-logo-claro)",
                                                        borderRadius: "50%",
                                                        border: "2px solid white"
                                                    }}
                                                ></span>
                                            )}
                                        </div>
                                    </a>
                                </li>
                                {/* mensajes */}
                                {/* <li className="nav-item">
                                    <a href="/mis-mensajes" className="nav-link text-dark" title="Mensajes">
                                    <i className="bi bi-envelope-paper-fill"></i>
                                    </a>
                                </li> */}
                                {/* favoritos */}
                                <li className="nav-item">
                                    <a href="/usuario/favoritos" className="nav-link text-dark" title="Favoritos">
                                    <i className="bi bi-heart-fill"></i>
                                    </a>
                                </li>
                                {/* reserva / carrito */}
                                <li className="nav-item">
                                    <a href="/reserva" className="nav-link text-dark" title="Reserva">
                                    <i className="bi bi-bag-fill"></i>
                                    </a>
                                </li>
                                {/* modo de usuario */}
                                <li className="nav-item d-flex align-items-center">
                                    <div className="form-check form-switch">
                                        <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        id="switchCheckDefault"
                                        checked={esComprador}
                                        onChange={cambiarModo}
                                        style={{
                                            backgroundColor: colorModo,
                                            borderColor: colorModo
                                        }}
                                        />
                                        <label className="form-check-label ms-2" htmlFor="switchCheckDefault">{usuario.modo}</label>
                                    </div>
                                </li>
                            </ul>

                            {/* Opciones verticales */}
                            <ul className="nav flex-column">
                                <li className="nav-item mb-2"><a href="/usuario/reservas" className="nav-link text-dark">Mis reservas</a></li>
                                <li className="nav-item mb-2"><a href="/usuario/pagos" className="nav-link text-dark">Mis pagos</a></li>
                                <li className="nav-item mb-1 pt-2 border-top border-1 border-dark mt-2"><a href="/usuario/mi-cuenta" className="nav-link text-dark">Mi cuenta</a></li>
                                <li className="nav-item mb-1 ">
                                    <button onClick={cerrarSesion} className="nav-link text-dark btn btn-link text-start text-decoration-none" type="button" >
                                        Cerrar sesión
                                    </button>
                                </li>
                            </ul>

                        </div>
                        :<div className="offcanvas-body">
                              <div className="mb-3">
                                <ToggleTema sobreFondoOscuro={false} />
                              </div>
                              <ul className="nav flex-column">
                                <li className="nav-item mb-2"><a href="/iniciar-sesion" className="nav-link text-dark">Iniciar Sesión</a></li>
                            </ul>
                        </div>
                        }
                    </div>


                    {/* FORMULARIO BUSQUEDA: MUESTRA EN PANTALLAS, OCULTO EN CELULARES  */}
                    <form onSubmit={handleBuscarHeader} className="col-12 d-lg-none col-lg-auto mt-3 mb-lg-0 me-lg-3" role="search" style={{ flexGrow: 2 }}>
                        <input
                            type="search"
                            className="form-control form-control-dark"
                            placeholder="Buscar..."
                            aria-label="Search"
                            value={busquedaHeader}
                            onChange={(e) => setBusquedaHeader(e.target.value)}
                        />
                    </form>
                </div>
            </div>
        </header>
 
        <hr />
        
        {/* menu slider inferior, solo cuando obtenga categorías */}
        { !categorias ? null : 
        <div className="container text-center pb-3">
            <div className="slider-outer">
                <div className="slider-container">
                {/* flecha */}
                    <div className="arrow left" onClick={() => scroll('left')}>&#10094;</div>
                    {/* menú */}
                    <div className="slider-scroll" ref={scrollContainerRef}>
                        { !categorias ? null : categorias.map((nombre, index) => (
                            <div key={index} className="custom-dropdown" onMouseEnter={(e) => handleMouseEnter(e, index)} onMouseLeave={handleMouseLeave} >
                                <h4
                                    className="custom-subtitle"
                                    onClick={() => irABusqueda({ categoria: nombre, subcategoria: null })}
                                    style={{ cursor: "pointer" }}
                                >
                                    {nombre}
                                </h4>
                            </div>
                        ))}
                    </div>
                    {/* felcha */}
                    <div className="arrow right" onClick={() => scroll('right')}>&#10095;</div>
                </div>
            </div>
        </div>
        }

        {/* Menú que se dibuja en posición absoluta */}
        {menuVisible && subcategorias && subcategorias[activeIndex] && (
        <div
            className="custom-dropdown-menu-global fade-in"
            style={{ top: menuPosition.top,  left: menuPosition.left, position: 'absolute', transform: 'translateX(-50%)' }}
            onMouseEnter={() => {
                if (hideMenuTimeoutRef.current) {
                    clearTimeout(hideMenuTimeoutRef.current);
                    hideMenuTimeoutRef.current = null;
                }
                setMenuVisible(true);
            }}
            onMouseLeave={handleMouseLeave}
        >
        {subcategorias[activeIndex].map((opcion, idx) => (
            <p key={idx}>
                <button
                    type="button"
                    className="btn btn-link p-0 text-decoration-none"
                    onClick={() => irABusqueda({
                        categoria: categorias?.[activeIndex] || null,
                        subcategoria: opcion,
                    })}
                >
                    {opcion}
                </button>
            </p>
        ))}
        </div>
        )}    
    </div>
    }
    </div>
    )
}

export default HeaderGlobal;

